import React, {Fragment} from 'react';
import {useDispatch} from 'react-redux';
import {inRecordCreation} from '../../store/reducers/RecordReducer';
import RecordsService from '../../services/RecordServices';
import strings from '../../values/strings';

const RecordModal: React.FC = () => {

  const dispatch = useDispatch();
  const [,,createRequest] = RecordsService.useCreateRecordAPI();

  return (
    <Fragment>
      <div className={'modal opened'}>
        <div className={'modal__content'}>
          <p className={'title'}>{strings.records.modal.title}</p>
          <p className={'copy'}>{strings.records.modal.copy}</p>
          <button className={'button-primary'} onClick={() => {createRequest();}}>
            <span>{strings.records.modal.action.confirm}</span>
          </button>
          <button className={'cancel'} onClick={() => dispatch(inRecordCreation(false))}>
            {strings.records.modal.action.cancel}
          </button>
        </div>
      </div>
    </Fragment>
  );
};

export default RecordModal;
